import iviewLocale from 'iview/src/locale/lang/mn-MN'

export default {
  locale: 'mn-MN',
  user: {
    defaultMenu: 'Меню по умолчанию',
    pleaseWait: 'Пожалуйста,подождите',
    role: 'роль',
    title: 'Лямбда платформа',
    subtitle: 'Лямбда платформа',
    login: 'Авторизоваться',
    forgot: 'Забыли пароль?',
    remember: 'Напоминать для этого компьютера',
    loginTitle: 'ВХОД В СИСТЕМУ',
    username: 'Имя пользователя',
    email: 'Электронная почта',
    password: 'Пароль',
    loginSuccess: 'Войден успешно. Пожалуйста, подождите секунду!',
    loginError: 'Неверный логин или пароль!!!',
    emailRequired: 'Введите адрес электронной почты',
    emailSendError: 'Произошла ошибка при отправке письма',
    forgotDescription: 'Введите свой адрес электронной почты и сбросьте пароль',
    sendPasswordResetCode: 'Получите код смены пароля по электронной почте',
    passwordConfirm: 'Подтверждения пароля',
    userNotFound: 'Пользователь не найден !!!',
    codeSentError: 'Ошибка отправки кода сброса пароля!',
    passwordReset: 'ОБНОВИТЬ ПАРОЛЬ',
    passwordResetCode: 'Код восстановления пароля',
    passwordResetCodeSent: 'Код на сброса пароля успешно отправлен!',
    passwordResetCodeRequired: 'Код смены пароля не введен!!!',
    passwordResetSuccess: 'Пароль успешно обновлен!',
    passwordConfirmError: 'Проверка пароля не удалась!!!',
    passwordResetCodeIncorrect: 'Код восстановления пароля неверен!!!',
    passwordResetCodeTimeout:
      'Срок действия кода восстановления пароля истек!!!',
    noReply:
      'Это письмо было отправлено автоматически, поэтому отвечать на него не требуется.',
    databaseview: 'Посмотреть базу данных',
    dataBase: 'база данных',
    view: 'Смотреть',
    add: 'Добавить',
    characteristics: 'Характеристики',
    basic: 'Начальный',
    column: 'Столбец',
    name: 'Имя',
    optional: 'Дополнительный',
    filter: 'Фильтр',
    data: 'Данные',
    save: 'Сохранить',
    tableList: 'Список таблиц',
    aggregation: 'Укрепление',
    sort: 'Сортировать',
    use: 'Использовать',
    grouping: 'Группировка',
    type: 'Тип',
    alias: 'Вымышленное имя',
    dataProcessing: 'Обработка данных',
    select: 'Пожалуйста, выбери',
    pleaseEnterSearchValue: 'Введите поисковый запрос...',
    user: 'пользователь',
    users: 'Пользователи',
    totalEmployees: 'Всего сотрудников',
    deleted: 'Удалено',
    searchForInformation: 'Поиск в информации',
    addUser: 'Добавить пользователя',
    noData: 'Информация не найдена',
    page: 'На Странице',
    shows: 'покажет',
    categorySearch: 'Судите по градусам',
    image: 'Картинка',
    lastName: 'Фамилия',
    firstName: 'Имя',
    registrationNumber: 'Регистрационный номер',
    dateOfBirth: 'Дата рождения',
    gender: 'Пол',
    men: 'Мужской',
    women: 'Женщина',
    phone: 'Телефон',
    resetFrom: 'Заполнить снова',
    permission: 'Хандах',
    loginName: 'Логин',
    confirmPassword: 'Проверка пароля',
    personalInformation: 'Персональная информация',
    changePassword: 'Изменить пароль',
    settings: 'Настройки',
    logOut: 'Выйти',
    pleaseSelectRole: 'Выберите роль',
    administraationRightsManagment: 'Управление доступом',
    additional: 'Дополнительный',
    dataSource: 'Источник информации',
    chart: 'График',
    userList: 'Список пользователей',
    import: 'Импортировать',
    register: 'Зарегистрироваться',
    confirm: 'Подтверждение',
    menuSelection: 'Выбрать меню',
    noMatchingData: 'Нет Сопоставление данных',
    nickName: 'Отображаемое имя',
    note: 'Объяснение',
    pleaseEnterVisibleName: 'Введите отображаемое имя',
    firstNameandLastName: 'Фамилия Имя',
    mobile: 'Сотовый телефон',
    createdDate: 'Дата создания',
    registrationregistrationConfirmedConfirmed: 'РЕГИСТРАЦИЯ ПОДТВЕРЖДЕНА',
    registrationIsNotConfirmed: 'РЕГИСТРАЦИЯ НЕ ПОДТВЕРЖДЕНА',
    success: 'Успешно',
    systemUpdate: 'Обновление системы',
    sendDataStructure: 'Отправка структур данных',
    pleaseReEnterYourPassword: 'введите еще раз ваш пароль',
    theValueIsRegistered: 'Значение зарегистрирована',
    possibleTableView: 'Доступная таблица и вид',
    table: 'Таблица',
    ascending: 'расти',
    descending: 'Убывание',
    byLoginName: 'В качестве имени для входа',
    dateAdded: 'Дата добавления',
    inPage: 'На странице',
    show: 'покажет',
    outOf: 'Общий',
    fromUsers: 'от пользователей',
    showing: 'Показывает',
    noInfo: 'Нет информации',
    ruconfinfo: 'Вы уверены что хотите восстановить данные сотрудников?',
    ruconfinfoDelete:
      'Вы уверены что хотите навсегда удалить данные сотрудников?',
    created: 'Созданный',
    userDeleted: 'Пользователь удален',
    _logout: 'Выйти',
    _cancel: 'Отменить',
    listOfDeletedUsers: 'Список удаленных пользователей',
    by: ' - через',
    no: 'Нет',
    yes: 'Да',
    completeDestruction: 'Полное удаление',
    recovery: 'Восстановить',
    errorOccWhileDeleting: 'Произошла ошибка при удалении',
    userInformationRestored: 'Информация о пользователе восстановлена.',
    errorOccurredWhileRetrievingData:
      'Произошла ошибка при востанавление данных.',
    total: 'Общий',
    edit: 'Починить',
    pleaseLogInUsingYourRegUnamePassword:
      'Пожалуйста, войдите, используя зарегистрированное имя пользователя и пароль!',
    frequentlyAskedQuestions: 'Часто задаваемые вопросы',
    toContaqt: 'связаться',
    downloadYourMobileApp: 'Загрузите мобильное приложение.',
    instructionsUse: 'Инструкции по использованию',
    hayg:
      'Монголия, г. Улан-Батор, Сухэ-Баторский район, 9-й квартал, дом 54, Компьютер Молл, 8-й этаж, номер 8002',
    plseResUrPassUsingUrRegisteredEmail:
      'Хотите сбросить пароль, используя зарегистрированный адрес электронной почты?',
    downloadAppHere: 'Загрузите приложение отсюда',

    learningManagementSystem: 'Система управления обучением',
    amjilt: 'Успех',
    system_features: 'Возможности системы',
    ebs: 'Средняя школа',
    web_site_data_monitoring: 'Мониторинг данных веб-сайта',
    training_data_statistics: 'Статистика данных обучения',
    schedule_report: 'Отчет по расписанию',
    track_by_keyword: 'Отслеживать по ключевому слову',
    to_calculate_the_program_choice_of_teachers_and_students:
      'Рассчитать выбор программы преподавателями и учениками',
  },
  agent_wizard: {
    confirm_registration_information: 'подтверждать Регистрационую информацию',
    step: 'Шаг',
    hello: 'Привет',
    your_name: 'Ваша Имя',
    your_last_name: 'Ваша Фамилия',
    name_desc:
      'Пожалуйста, напишите свое настоящее имя латинскими или монгольскими буквами длиной до 75 символов.',
    last_name_desc:
      'Пожалуйста, напишите свою фамилию латинскими или монгольскими буквами длиной до 75 символов.',
    your_birthday: 'Ваша дата рождения',
    your_gender: 'Ваш пол',
    women: 'Женщина',
    man: 'Мужской',
    _register: 'Регистрационный номер',
    register_desc:
      'Пожалуйста, введите свой регистрационный номер. Пожалуйста, пишите только монгольскими буквами.',
    example: 'Например',
    contact_information: 'Контактная информация',
    your_email_address: 'Ваш электронный адрес',
    email_desc:
      'Пожалуйста, введите Ваш адрес электронной почты. Пожалуйста, пишите латинскими буквами, строчными буквами и без пробелов.',
    your_phone_number: 'Ваш номер мобильного телефона',
    phone_desc:
      'Пожалуйста, введите номер вашего мобильного телефона. Используйте только цифры и никаких пробелов между ними.',
    profile_image: 'Изображение профиля',
    profile_image_uploud: 'Добавить изображение профиля',
    profile_desc:
      'Пожалуйста, выберите изображение своего профиля и загрузите его на сервер. Размер изображения не должен превышать 1 МБ при четных соотношениях сторон.',
    your_new_password: 'ваш новый пароль',
    password_desc:
      'Пароль должен быть написан латинскими буквами, содержать буквы верхнего и нижнего регистра, цифры, специальные символы и не содержать пробелов.',
    rep_your_new_password: 'Подтвердите новый пароль',
    _prev: 'Предыдущий',
    _next: 'Следующее',
    enter_personal_information:
      'Пожалуйста, вводите свои персональные данные правильно!',
    enter_contact_information:
      'Пожалуйста, вводите свои контактные данные правильно!',
    please_change_your_password:
      'Пожалуйста, измените свой пароль! Ваш новый введенный пароль будет использоваться в будущем.',
    please_contact_system_administor:
      'Если вам нужна помощь, пожалуйста, свяжитесь с системным администратором',
    back: 'Возвращаться',
    entered_information: 'Информация, которую вы предоставляете',
    information_alert:
      'Пожалуйста, проверьте свою информацию и отправьте ее в систему, если она верна.',
    no_information: 'нет информации',
    date_you_added_system: 'Дата вашего добавления в систему',
    send_registration: 'Отправить регистрацию',
    userDeleted: 'Пользователь удален.',
    errorOccurredDeleting: 'При удалении произошла ошибка.',
    UserInformationRestored: 'Информация о пользователе восстановлена.',
    ErrorRetrievingData: 'Произошла ошибка при получении данных!',
    NoSearchResultsFound: 'Результаты поиска не найдены!',
    SpacesAreIncluded: 'Пространство введено.',
  },
  adminModule: {
    db: 'База данных',
    usersAndUserGroups: 'ПРАВА ПОЛЬЗОВАТЕЛЯ И ДОСТУПА',
    users: 'Пользователи',
    userGroupsPermission: 'Доступ и согласие',
    sendDBSchema: 'Отправьте структуру базы данных',
    AddColumn: 'Добавить столбец',
    systemUpdate: 'Обновление системы',
    graphic: 'График',
    column: 'Столбец',
    dataType: 'Тип данных',
    form: 'Форма',
    table: 'Таблица',
    original_preparation: 'Начальная подготовка',
    pleaseWait: 'Пожалуйста, подождите!!',
    _form: 'Форма',
    value_column: 'Столбец значений',
    Custom_column: 'Столбец пользователя',
    list_grid: 'Список | Сетка (фильтр)',
    judgment_column: 'Колонка для судейства',
    form_value: 'Форма (получение значения)',
    InformationSuccessfullyDistributed: 'Данные успешно распределены!лаа!',
    InformationReturned: 'Информация вернулась!',
  },
  graphql: {
    graphqlManagement: 'Graphql-управление',
    table: 'Таблица',
    selectTable: 'Выберать таблицу',
    name: 'Имя',
    idField: 'Поле идентификатора',
    hideFields: 'Скрыть поля',
    permissionActions: 'Действия для утверждения',
    add: 'Добавить',
    edit: 'Починить',
    delete: 'Удалить',
    save: 'Сохранить',
    accessAndAccessRights: 'Вход и доступ',
    nevtersenHundHaruulah: 'Показывается вошедшему человеку.',
    accessRights: 'Видимый доступ',
    allUsersCanSee:
      'Все пользователи могут просматривать, если не получено разрешение.',
    subTables: 'Подтаблицы',
    subTable: 'Подтаблица',
    connectionField: 'Поле подключения',
    tableList: 'Список таблиц',
    viewList: 'Посмотреть список',
    real_time: 'Заказ в режиме реального времени',
    cancel: 'Останавливаться',
    tableParentId: 'Идентификатор родительской таблицы',
    action: 'Действие',
  },
  components: {
    add: 'Добавить',
    pleaseEnterSearchValue: 'Введите поисковый запрос...',
    pleaseWait: 'Пожалуйста, подождите секунду!',
    deleteData: 'Удалить данные?',
    name: 'Имя',
    yes: 'Да',
    no: 'Нет',
    copy: 'Копировать',
    table: 'Таблица',
    basicTable: 'Основная таблица',
    selectTable: 'Выберите таблицу',
    applications: 'Программы',
    additions: 'Добавки',
    logistics: 'Логистика',
    letter: 'Письмо',
    fileDirectory: 'Библиотека файлов',
    admin: 'администратор',
    systemAdministrator: 'Системный администратор',
    personalInformation: 'Персональная информация',
    settings: 'Настройки',
    logOut: 'Выйти',
    changePassword: 'Изменить пароль',
    projectList: 'Список проектов',
    table_list: 'Список таблиц',
    ui_builder: 'конструктор пользовательского интерфейса',
    _form: 'Форма',
    someContents: 'Некоторый контент',
    _cancel: 'Останавливаться',
  },
  chart: {
    horizontal_value: 'Значение креста',
    groupBy: 'группировать',
    line: 'Линейка',
    _big: 'большой',
    _small: 'Маленький',
    field: 'Поле',
    settings: 'Настройки',
    icon: 'изображение',
    bg_color: 'фоновый цвет',
    text_color: 'Цвет текста',
    link_title: 'ссылка на заголовок',
    link: 'связь',
    values: 'значение',
    element_type: 'тип элемента',
    _filter: 'фильтр',
    _name: 'имя',
    responsible_value: 'Смысл ответственности',
    _save: 'Сохранять',
    enter_name: 'Введите имя...',
    data_table: 'Өгөгдлийн хүснэгт',
    selectTable: 'Таблица данных',
    aggregation: 'Укрепление',
    no: 'Нет',
    count: 'Номер',
    _max: 'Большинство',
    _min: 'по меньшей мере',
    _avg: 'Средний',
    _sum: 'Сумма',
    count_distinct: 'Номер',
    avg_distinct: 'Средняя разница',
    sum_distinct: 'суммирование признаков',
    _sort: 'Сортировка',
    no_sort: 'Не отсортировано',
    grouping: 'Группировка',
    _type: 'Тип',
    fictitious_name: 'Вымышленное имя',
    _color: 'цвет',
  },
  dataForm: {
    resetFrom: 'Заполнить новый',
    save: 'Сохранять',
    pleaseWait: 'Пожалуйста, подождите секунду!',
    fillInTheNewOne: 'Заполните новый',
    close: 'Закрывать',
    basicSettings: 'базовые настройки',
    configureTheData: 'Установить данные',
    trigger: 'курок',
    informationLink: 'Информационная ссылка',
    GetValuesFromTheTable: 'Получить значение из таблицы',
    Geographic: 'Географический',
    AdditionalValues: 'Дополнительные значения',
    selectMultipleImg: 'Следует ли выбирать несколько изображений',
    TypeOfTheEditor: 'Тип редактора',
    Placeholder: 'Заменять',
    default_Value: 'Значение по умолчанию',
    Get_value_parameter: 'Получить значение из параметра',
    Parameter_name: 'Имя параметра',
    Get_user_ID: 'Получать или нет идентификатор пользователя',
    Consolidation_formula: 'Формула агрегирования',
    Whether_to_summarize: 'Стоит ли показывать это вместе',
    Choose_a_formula: 'Выберите формулу',
    Formula_type: 'Тип формулы',
    Take_the_word_before_merger: 'Чтобы поговорить перед встречей',
    example: 'Например',
    total: 'общий',
    number: 'число',
    ets: 'и т. д.',
    Symbol: 'Символ',
    get_sign_after_merger: 'Если вы получили оценки после консолидации',
    Verification_conditions: 'проверить условия',
    Form_of_data_verification: 'Форма проверки данных',
    Password_settings: 'Настройки пароля',
    Password_verification: 'Проверка пароля',
    _pass: 'Пароль',
    Create_a_password: 'Создать пароль',
    Check_password_during_editing: 'Проверка пароля при редактировании',
    number_precision: 'Точность кровати',
    Whether_get_values_database: 'Получать ли значения из базы',
    Choose_multiple_values: 'Выберите несколько значений',
    value: 'Значение',
    visible_word: 'Видимое слово',
    visible_thumb: 'Посмотреть изображение',
    add: 'Добавлять',
    table: 'Таблица',
    selectTable: 'Выбирать таблицу',
    Related_fields: 'Связанное поле',
    Visible_fields: 'Видимые поля',
    Select_fields: 'Выберите поля',
    Sort_field: 'Поле сортировки',
    Father_column: 'Родительский столбец',
    form: 'в форме',
    this_table: 'этой таблицы',
    Display_Add_Data_button: 'Показать кнопку «Добавить данные»',
    Add_data_Form: 'Добавить форму данных',
    List_of_tables: 'Список таблиц',
    Link_terms: 'Условия ссылки',
    Get_customer: 'Получить от пользователя',
    Custom_column: 'Столбец пользователя',
    judgment_column: 'Колонка для судейства',
    Call_from_server: 'Звонок с сервера',
    data_loading_URL: 'URL для получения данных',
    Trigger_load_time: 'Время вызвать триггер',
    Example_data_returned_server: 'Пример данных для возврата с сервера',
    Successful: 'Успешно',
    URL_call_information_link: 'URL для вызова ссылки на данные',
    Value_table: 'таблица для получения значений',
    Value_return_field: 'поле возвращаемого значения',
    Geographic_settings: 'географическое положение',
    attribute: 'атрибут',
    properties: 'характеристики',
    Geometric_type: 'Геометрический тип',
    point: 'точка',
    line: 'Линейка',
    polygon: 'многоугольник',
    length_center: 'центральная долгота',
    latitude_center: 'Центральная широта',
    Map_magnification: 'Увеличение карты',
    Background_map: 'изображение на заднем плане',
    Google_Street: 'Гугл-стрит',
    Google_Space: 'Google Космос',
    Open_Street_Map: 'Открыть изображение улицы',
    Check_overlap_area: 'Проверка перекрытия полей',
    Feature_Class_link: 'Ссылка на класс функции',
    Search_field: 'поле поиска',
    Search_value_field: 'поле для получения искомого значения',
    Success_message: 'Сообщение об успехе',
    Error_message: 'Сообщение об ошибке',
    Form_name: 'Название формы',
    Sub_name: 'Субтитры',
    Form_type: 'Тип формы',
    Simple_form: 'Простая форма',
    Step_by_step_form: 'Форма с шагами',
    data_table: 'Таблица данных',
    idField: 'Поле идентификатора',
    Date_generated_automatically: 'Дата будет сгенерирована автоматически',
    render_by_tab: 'Сделать раздел вкладкой',
    Label_location: 'Расположение этикетки',
    Form_width: 'Ширина формы',
    Save_button_word: 'Сохранить слово кнопки',
    Padding_spacing: 'Padding - расстояние',
    model: 'модель',
    displayName: 'Отображаемое имя',
    hide: 'Скрывать',
    inactive: 'Неактивный',
    translation: 'Перевод',
    formula: 'Формула',
    userInterface: 'Появление',
    _subform: 'Подформа',
    _form: 'Форма',
    formula_conditions: 'Формулы и условия',
    field: 'Поле',
    basic_from: 'Основная форма',
    conditions: 'условия',
    add_a_field: 'Добавить поле',
    controller_namespace: 'Пространство имен контроллера',
    namespace: 'Пространство имен',
    before_insert: 'Прежде чем добавлять',
    after_insert: 'После добавления',
    before_update: 'Перед обновлением',
    after_update: 'После обновления',
    _type: 'Тип',
    _top: 'вершина',
    _left: 'левый',
    Choose_type: 'выберите тип',
    min_height: 'минимальная высота',
    Close_deletion_action: 'Закрыть действие удаления',
    close_add_ons_action: 'Закрыть действие добавления',
    row_numbering: 'нумерация строк',
    Use_table_type: 'Используйте типы таблиц',
    Table_Type_field: 'Поле типа таблицы',
    Table_Type_value: 'Значение типа таблицы',
    Consolidation_forms_and_tables: 'форма и табуляция',
    _link: 'Связь',
    iframe_page: 'страница iframe',
    no_action_sub_top: 'Отображать верхнее меню без действий',
    No_action: 'Бездействие',
    _division: 'Разделение',
    menuType: 'Тип меню',
    connectionPath: 'Соединительная дорога',
    name: 'Имя',
    target: 'Назначение',
    self: 'сам',
    blank: 'пустой',
    _new: 'Новый',
    Get_name: 'Чтобы получить имя',
    section_add: 'Добавить раздел',
    add_column: 'Добавить столбец',
    _delete: 'Удалить',
    _move: 'Двигаться',
    graphicsManagement: 'Управление графикой',
    viewPhotos: 'Посмотреть фотографии',
    createNumber: 'Создать номер',
    other: 'Другие',
    download: 'Остановить',
    view: 'Видеть',
    pleaseSelectFile: 'выберите свой файл',
    longitude: 'Долгота',
    latitude: 'Широта',
    cancel: 'Останавливаться',
    enterCoordinatesPressEnter: 'Введите замену и нажмите Enter?',
    clickHereSelectPhoto: 'Нажмите здесь, чтобы выбрать свою фотографию!',
    notFound: 'Не найдено',
    confirmPassword: 'Проверка пароля',
    currentPassword: 'Текущий пароль',
    pleaseWriting: 'Пожалуйста, напишите',
    fromCityCenter: 'Из центра города',
    please_enter_value: 'Пожалуйста, введите значение',
    formInformationSavedSuccessfully: 'Информация формы успешно сохранена.',
    please_enter_formula: 'Введите вашу формулу',
    savedSuccessfull: 'Успешно сохранено',
    errorSaving: 'При сохранении произошла ошибка!',
    formIformationSavedSuccessfull: 'Информация формы успешно сохранена.',
    successDeleted: 'Удален успешно!',
    selectDefaultMenu: 'Выберите меню по умолчанию',
    selectMenu: 'Выберите меню',
    pleaseEnterPasswordYouUCurrentlyUsing:
      'Пожалуйста, введите ваш текущий пароль',
    pleaseReEnterYourPassword: 'Повторно ввести пароль?',
    passwordConfirmError: 'Проверка пароля не удалась!!!',
    informationIsIncomplete: 'Информация неполная',
    trRMandatoryFieldsFillInformationLookFormAFillRequiredFieldsWithRedBorder:
      'В процессе заполнения информации имеются обязательные поля. Посмотрите форму и заполните обязательные поля, отмеченные красным!',
    successfullySaved: 'Успешно сохранено.',
    pleaseDeleteSubDForm: 'Удалить подчиненную форму',
    thereZNoRightChangeInformation: 'Нет права изменять информацию',
    enterCoordinatesCorrectly: 'Пожалуйста, введите правильный пароль',
    error: 'Ошибка',
    theSiteHasNotBeenSelected: 'Поле не выбрано',
    noSiteFound: 'Поле не найдено',
    dataNotFound: 'Данные не выбраны',
    pleaseCompleteFirstLine: 'Завершите первую строку',
    search: 'Поиск',
    values: 'Значение',
    all: 'Все',
  },
  dataGrid: {
    infoCourt: 'Информационный суд',
    filtering: 'Судить',
    ruSureYouDeleteInfo: 'Вы уверены, что хотите удалить эту информацию?',
    yes: 'Да',
    no: 'Нет',
    total: 'Общий',
    updateDataFromExcelFile: 'Обновить данные из файла Excel',
    default_Value: 'Значение по умолчанию',
    methodOfComparison: 'Метод сравнения',
    parameterComparison: 'Сравнение параметров',
    whetherLookSidebarSearch: 'Видимость в поиске на боковой панели',
    dataLink: 'Канал передачи данных',
    data_settings: 'Настройки данных',
    basicSettings: 'Базовые настройки',
    selectTable: 'Выберите стол',
    table: 'Таблица',
    tableList: 'Список таблиц',
    Related_fields: 'Связанное поле',
    Visible_fields: 'Видимые поля',
    Select_fields: 'Выберите поля',
    Select_field: 'Выберите поле',
    Sort_field: 'Поле сортировки',
    Father_column: 'Родительский столбец',
    Link_terms: 'Условия ссылки',
    inSearch: 'в суде',
    this_table: 'этой таблицы',
    Get_customer: 'Получить от пользователя',
    custom_column: 'Столбец пользователя',
    judgment_column: 'Колонка для судейства',
    viewList: 'Посмотреть список',
    image: 'картина',
    values: 'значение',
    visible_word: 'Видимое слово',
    add: 'Добавлять',
    linkSettings: 'Настройки ссылки',
    insertList: 'Вставить ссылку',
    linkIcon: 'Значок ссылки',
    showOnlyIcon: 'Отображать только изображение',
    pinColumn: 'Прибивание колонны',
    linkType: 'Тип ссылки',
    pinPosition: 'Место кошения',
    onLeft: 'с левой стороны',
    onRight: 'на правой стороне',
    radioSettings: 'Настройки радио',
    additionalSettings: 'Дополнительные настройки',
    comparativeValue: 'Сравнительное значение',
    icon: 'икон',
    colorCode: 'Цветовой код',
    easyEdit: 'Легко исправить',
    copy: 'Копировать',
    view: 'Видеть',
    columnFilterButton: 'Кнопка фильтра столбца',
    displayTableFrame: 'Показать диапазон таблицы',
    displayMenuColumn: 'Отображение меню в столбцах',
    showFullText: 'Показать полный текст',
    reboot: 'Перезагрузить',
    download: 'Остановить',
    pleaseSelectFile: 'выберите свой файл',
    excelUpload: 'Загрузите файл Excel',
    exportExcel: 'Экспортировать файл Excel',
    landScape: 'горизонтальный',
    portrait: 'вертикальный',
    paperSize: 'Размер бумаги',
    print: 'Распечатать',
    saveSearch: 'Сохранить поиск',
    pivotTool: 'Инструмент поворота',
    clientRender: 'Клиентский рендеринг',
    numbered: 'пронумерован',
    comparisonModel: 'модель сравнения',
    selectSameValues: 'выберите те же значения',
    multipleLinesChooseFrom: 'выбрать несколько строк одновременно',
    width: 'широкий',
    staticWidth: 'Статическая ширина',
    destroyedCanBeRestored: 'Удаленное можно восстановить',
    paging: 'нумерация страниц',
    edit: 'Редактировать',
    name: 'Имя',
    basic: 'базовый',
    basicTable: 'Основная таблица',
    idField: 'Поле идентификатора',
    data_table: 'Таблица данных',
    pleaseWait: 'Пожалуйста, подождите секунду!',
    save: 'Сохранять',
    appearanceName: 'отображаемое имя',
    hide: 'Скрывать',
    court: 'суд',
    searchResults: 'Появиться в поиске',
    translation: 'Перевод',
    tobePublished: 'Будет опубликован',
    updateSelectedLineData: 'Обновить данные для выбранной строки',
    whenEnteringDataFromExcelFile: 'Ввод данных из файла Excel',
    filtersettings: 'Настройки фильтра',
    excel: 'превосходить',
    model: 'Модель',
    updateSelectedLineDataSettings:
      'Настройки обновления данных для выбранной строки',
    fieldName: 'Имя поля',
    buttonName: 'Название кнопки',
    updateAndReboot: 'Обновить и перезагрузить',
    countingAssociatedInfo: 'Перечислить связанную информацию',
    relatedTable: 'связанная таблица',
    relatedFields: 'Связанное поле',
    fatherField: 'родительское поле',
    consolidationFormulas: 'Комбинации и формулы',
    formula: 'Формула',
    resultsStorageArea: 'Поле для сохранения результатов',
    consolidation: 'Укрепление',
    consolidationType: 'Тип агрегации',
    consolidationFormula: 'формула суммирования',
    conditionTrigger: 'Условия и триггеры',
    beforeCallingFromDatabase: 'перед вызовом из базы данных',
    afterCallingFromDatabase: 'после звонка из базы данных',
    beforeDeleting: 'Перед удалением',
    afterDeleting: 'После удаления',
    beforePrinting: 'перед печатью',
    cacheClearTriggerLabel: 'Ссылка на очистку кэша',
    spreadsheetForm: 'Табличная форма',
    fromType: 'Тип формы',
    update: 'Быть обновленным',
    post: 'Публиковать',
    editable_UpdateLink: 'редактируемое — обновление ссылки',
    fixEntireLine: 'редактировать полной строкой',
    switchEditMode: 'перейти в режим редактирования',
    withOneClick: 'одним щелчком мыши',
    highlightChanges: 'Определить изменения',
    saveChangesBulk: 'Массовое сохранение изменений',
    gbExcelImport: 'Импорт Excel',
    excelImportFieldName: 'Имя столбца Excel',
    excelImportFormTitle: 'Настройки во время ввода Excel',
    excelUploadSampleFile: 'Включить пример файла',
    excelUploadRowtoStart: 'Номер строки, чтобы начать чтение файла Excel',
    excelUploadCustomUrl:
      'Пользовательская ссылка для использования при копировании файла Excel.',
    excelImportModalTitle: 'Импортировать данные из файла Excel',
    appearance: 'Появление',
    dataTable: 'Таблица данных',
    filter: 'Фильтр',
    mini: 'Мини',
    simple: 'Простой',
    size: 'Размер',
    controllerNameSpace: 'возможные действия руководства',
    namespace: 'Пространство имен',
    beforeFetch: 'Прежде чем принимать',
    afterFetch: 'после принятия',
    symbol: 'знак',
    type: 'Тип',
    nickName: 'отображаемое имя',
    filtersAndSelectedLineSettings: 'настройки фильтра и выбранной строки',
    sort: 'Сортировка',
    column: 'Столбец',
    delete: 'Удалить',
    actions: 'Действия',
    firstColumn: 'в первом столбце',
    buttonEdit: 'Быстрое решение',
    doubleClicktoEdit: 'дважды щелкните, чтобы редактировать',
    actionsField: 'поле действий',
    performActionWithMouse: 'выполнять действия с помощью мыши',
    renew: 'обновлять',
    tableHeaderTemplate: 'шаблон заголовка таблицы',
    createHeaderTemplate: 'Создайте шаблон заголовка',
    addLine: 'добавить строку',
    addLineBelow: 'Добавьте строку ниже',
    deleteThisLine: 'Удалить эту строку?',
    addColumnAfterThisColumn: 'Добавить столбец после этого столбца',
    pleaseDeleteThisCell: 'удалить этот ящик',
    checkModel: 'Проверка модели',
    height: 'высота',
    widthu: 'широкий',
    row: 'линия',
    selectPaperSize: 'Выберите размер бумаги',
    currencySelection: 'Выберите валюту',
    tugrug: 'МНТ',
    dollar: 'Доллар',
    euro: 'Евро',
    yen: 'Японский иен',
    austDollar: 'Австрали доллар',
    rubli: 'Рубль',
    choosevalue: 'Выберите значение',
    pleaseWaitForLoading: 'подожди, пока он загрузится',
    successfullySaved: 'Успешно сохранено.',
    formInformationSavedSuccessfully: 'Информация формы успешно сохранена.',
    anErrorOccurredWhileSaving: 'При сохранении произошла ошибка!',
    successfullyDeleted: 'Удален успешно!',
    makeExcel: 'Вывод Excel',
    plseEnterValue: 'Пожалуйста, введите значение',
    updatedSuccessfully: 'Успешно обновлено',
    infoDeleted: 'Данные удалены',
    tableDataHasBeenSuccessfullyEdited:
      'Информация в таблице успешно исправлена.',
    formInfoSavedSuccessfully: ' Информация формы успешно сохранена.',
    errorOccurredWhileUpdating: ' При обновлении произошла ошибка.',
    pleaseSelectUpdateLine: ' Выберите строку для обновления.',
    errorOccWhileDeleting: 'Произошла ошибка при удалении',
    errorMsg: 'Извините произошла ошибка',
    noChangesHaveBeenReported: 'Обновленной информации нет',
    theme: 'Модель',
  },
  dataSource: {
    database: 'База данных',
    add: 'Добавлять',
    view: 'видеть',
    pleaseEnterSearchValue: 'Введите поисковый запрос...',
    pleaseWait: 'Пожалуйста, подождите секунду!',
    yes: 'Да',
    no: 'Нет',
    deleteData: 'Удалить данные?',
    dataProcessing: 'Обработка данных',
    characteristics: 'Характеристики',
    basic: 'Базовый',
    column: 'Столбец',
    name: 'Имя',
    additional: 'Дополнительный',
    filter: 'фильтр',
    data: 'Данные',
    save: 'Сохранять',
    tableList: 'Список таблиц',
    viewList: 'Посмотреть список',
    aggregation: 'Укрепление',
    sort: 'Сортировка',
    noSort: 'Не отсортировано',
    use: 'Использовать',
    grouping: 'Группировка',
    type: 'Тип',
    alias: 'Тип',
    select: 'Выбирать',
    bolomjitTableAndView: 'Доступная таблица и вид',
    selectTable: 'Выберите таблицу',
    applications: 'Програмы',
    errorOccurredWhileSaving: 'При сохранении произошла ошибка!',
  },
  role: {
    administraationRightsManagment: 'УПРАВЛЕНИЕ ДОСТУПОМ',
    welcome: 'Добро пожаловать!',
    loggedIn: 'Вошедший пользователь',
    personalInfo: 'Персональная информация',
    changePass: 'Изменить пароль',
    superAdminManagement: 'Суперадминистраторское управление',
    logout: 'Выйти',
    pleaseWait: 'Пожалуйста, подождите секунду!',
    add: 'Добавлять',
    pleaseSelectRole: 'Выбрать роль?',
    role: 'Роль',
    additional: 'Дополнительный',
    dataSource: 'Источник информации',
    userList: 'Список пользователей',
    import: 'Импортировать',
    register: 'регистр',
    confirm: 'Подтверждение',
    save: 'Сохранять',
    menuSelection: 'Выбрать меню',
    possibleTableView: 'Возможная таблица и вид',
    table: 'Таблица',
    name: 'Имя',
    displayName: 'Отображаемое имя',
    note: 'Объяснение',
    cancel: 'Останавливаться',
    defaultMenu: 'Меню по умолчанию',
    chart: 'Графика',
    tableName: 'Название таблицы',
    table_name: 'Имя таблицы',
  },
  project: {
    project: 'ПРОЕКТ',
    settings: 'Настройки',
    data_recording_environment: 'СОВРЕМЕННЫЙ ГЕНЕРАТОР ВВОДА ДАННЫХ',
    _form: 'Форма',
    table: 'Стол',
    form_and_table_consolidation: 'Объединение форм и таблиц',
    data_processor: 'ИНФОРМАЦИОННЫЙ ПРОЦЕССОР',
    _chart: 'Графика',
    original_preparation: 'Начальная подготовка',
    analysis: 'Анализ',
    target_statement: 'Уведомление о целевом использовании',
    graphql_management: 'Graphql-управление',
    menu: 'МЕНЮ',
    menu_settings: 'Настройки меню',
    data_settings: 'Настройки данных',
    project_key: 'Ключ к проекту',
    server_languege_framework: 'Серверный язык и фреймворк',
    create_using: 'создавать, используя',
    download_create_file: 'Создать загрузку файла',
    lambda: 'Лямбда',
    lambda_cli: 'Лямбда CLI',
    lambda_example_app: 'Пример приложения Lambda',
    l_key: 'ключ',
    create: 'создавать',
    lambda_settings: 'Лямбда-конфигурация',
    laravel_framework: 'PHP: фреймворк Laravel',
    go_framework: 'Go: платформа Echo',
    database: 'База данных',
    database_connect: 'Подключение к базе данных',
    ready: 'Готовый',
    _success: 'Удачи',
    type: 'тип',
    manage_access_rights: 'Управление доступом',
    add: 'Добавлять',
    menuSelection: 'Выбрать меню',
    default_menu: 'Меню по умолчанию',
    lambda_platform: 'композитор создать проект лямбда-платформы/laravel',
    composer: 'Композитор',
    _save: 'Сохранять',
    optional: 'Дополнительный',
    data_source: 'Источник информации',
    _moqup: 'Макет',
    user_list: 'Список пользователей',
    _import: 'Импортировать',
    register: 'регистр',
    _confirm: 'Подтверждение',
    deleteData: 'Удалить данные?',
    form_value: 'Форма (получение значения)',
    alertSelectColumns: 'Выберите соответствующие команды',
    errorMsg: 'Извините произошла ошибка',
    please_wait: 'Пожалуйста, подождите секунду',
  },
  puzzle: {
    manage_access_rights: 'Управление доступом',
    data_recording_environment: 'СОВРЕМЕННЫЙ ГЕНЕРАТОР ВВОДА ДАННЫХ',
    _form: 'Форма',
    table: 'Таблица',
    form_and_table_consolidation: 'Объединение форм и таблиц',
    web_page: 'веб-страница',
    data_processor: 'ИНФОРМАЦИОННЫЙ ПРОЦЕССОР',
    data_settings: 'Настройки данных',
    _chart: 'Графика',
    original_preparation: 'Начальная подготовка',
    _report: 'Отчет',
    analysis: 'Анализ',
    target_statement: 'Уведомление о целевом использовании',
    graphql_management: 'Graphql-управление',
    usersAndUserGroups: 'ПРАВА ПОЛЬЗОВАТЕЛЯ И ДОСТУПА',
    users: 'Потребители',
    userGroupsPermission: 'Доступ и согласие',
    menu_settings: 'Настройки меню',
    logOut: 'Выйти',
    cancel: 'Отказаться',
    please_wait: 'Пожалуйста, подождите секунду',
    add: 'Добавлять',
    _save: 'Сохранять',
    optional: 'Дополнительный',
    duties: 'Ответственность',
    _name: 'Имя',
    appearance_name: 'Отображаемое имя',
    note: 'Объяснение',
    please_select_role: 'Выберите роль',
    data_source: 'Источник информации',
    _moqup: 'Макет',
    user_list: 'Список пользователей',
    _import: 'Импортировать',
    default_menu: 'Меню по умолчанию',
    register: 'регистр',
    _confirm: 'подтверждать',
    list_grid: 'Список | Сетка (фильтр)',
    custom_column: 'Столбец пользователя',
    judgment_column: 'Колонка для судейства',
    value_column: 'Столбец значений',
    delete_data: 'Удалить данные',
    menuSelection: 'Выбрать меню',
    not_found: 'не найдено',
    meaningTake: 'Ценность, которую нужно получить',
    filter: 'Фильтр',
  },
  notify: {
    notice: 'Уведомления',
    no_notice: 'Объявлений пока нет!',
    view_all_notifications: 'Просмотреть все уведомления',
    total: 'Общий',
    clear_notification: 'Пусть все это увидят',
  },
  appAdmin: {
    manual: 'Руководство',
    logOut: 'Логоут',
    cancel: 'Останавливаться',
    add: 'Добавлять',
    minus: 'Удалять',
    pleaseWait: 'Пожалуйста, подождите секунду!',
    pleaseEnterSearchValue: 'Введите поисковый запрос...',
    delete_data: 'Удалить данные?',
    no: 'нет',
    yes: 'да',
    settings: 'Настройки',
    menu_location: 'Расположение меню',
    stepped: 'иерархический',
    stepped_small: '  Иерархический малый',
    decomposes: 'Распадается',
    cross: 'Через',
    color_selection: 'Выбор цвета',
    dark_mode: 'Темный режим',
    bright_mode: 'Яркий режим',
    description:
      'При добавлении агентов вводите их сверху вниз, чтобы получить правильную информацию о маршруте?',
    data_processor: 'Процессор данных',
    original_preparation: 'Начальная подготовка',
    dataProcessing: 'Обработка данных',
    graphics_generator: 'Графический генератор',
    point: 'Точка',
  },
  moqup: {
    elements: 'Элементы',
    chart: 'Графика',
    save: 'Сохранять',
    embedlink: 'Вставить ссылку',
    edit: 'Починить',
    phone: 'телефон',
    tablet: 'Таблетка',
    computer: 'Компьютер',
    bigComputer: 'Большой компьютер',
  },
  page: {
    pageNotFound: 'Страница не найдена.',
  },
  alertMessage: {
    anErrorOccurredWhileSaving: 'При сохранении произошла ошибка!',
    successfullyDeleted: 'Удален успешно!',
    plseEnterValue: 'Пожалуйста, введите значение',
    updatedSuccessfully: 'Успешно обновлено',
    infoDeleted: 'Данные удалены',
    savedSuccessfull: 'Успешно сохранено',
    confirm: 'Подтверждение',
    errorOccurredWhileUpdating: ' При обновлении произошла ошибка.',
    pleaseSelectUpdateLine: ' Выберите строку для обновления.',
    errorOccWhileDeleting: 'Произошла ошибка при удалении',
    errorMsg: 'Извините произошла ошибка',
    noChangesHaveBeenReported: 'Обновленной информации нет',
    pleaseWait: 'Пожалуйста, подождите секунду!',
    userDeleted: 'Пользователь удален',
    successDeleted: 'Удален успешно!',
    userInformationRe: 'Информация о пользователе восстановлена.',
    errorRetriev: 'Произошла ошибка при получении данных!',
    notFound: 'Результаты поиска не найдены!',
    imformation_registered:
      'Ваша информация успешно зарегистрирована. Пожалуйста, подождите секунду',
    errorServer: 'На сервере произошла ошибка',
    errorSendingMail: 'Произошла ошибка при отправке письма',
    please_enter_value: 'Пожалуйста, введите значение',
    formInformationSavedSuccessfully: 'Информация формы успешно сохранена.',
    please_enter_formula: 'Введите вашу формулу',
    errorSaving: 'При сохранении произошла ошибка!',
    formIformationSavedSuccessfull: 'Информация формы успешно сохранена.',
    selectDefaultMenu: 'Выберите меню по умолчанию',
    selectMenu: 'Выберите меню',
    form_value: 'Форма (получение значения)',
    alertSelectColumns: 'Выберите соответствующие команды',
    please_wait: 'Пожалуйста, подождите секунду',
    pageNotFound: 'Страница не найдена',
  },
  crud: {
    registration_history: 'История регистрации',
    Information_viewing_history: 'Посмотреть историю',
    _add: 'Добавлять',
    _save: 'Сохранять',
    re_call: 'Перезагрузить',
    _print: 'Распечатать',
    download_file: 'Скачать с файлом Excel',
    excelUpload: 'Импортировать данные из файла Excel',
  },
  // "custom": {
  //     "learningManagementSystem": "Сургалтын удирдлагын систем",
  //     "amjilt": "Амжилт",
  //     "system_features": "Системийн боломжууд",
  //     "ebs": "ЕБС",
  //     "web_site_data_monitoring": "Вэб сайтын мэдээлэл хяналт",
  //     "training_data_statistics": "Сургалтын мэдээллийн статистик",
  //     "schedule_report": "Цагийн хуваарийн тайлан",
  //     "track_by_keyword": "Түлхүүр үгээр хянах",
  //     "to_calculate_the_program_choice_of_teachers_and_students": "Багш сурагчдын хөтөлбөр сонголтыг тооцоолох",
  // },
  i: { ...iviewLocale.i },
}
